<template>
    <tr>
        <td class="table-status__error">
            <div>
                <v-tooltip top v-if="value.invalido">
                    <v-icon slot="activator" small color="red">error_outline</v-icon>
                    <div v-html="value.mensagem"></div>
                </v-tooltip>
            </div>
        </td>
        <td class="small-colunm">
          {{ descricaoLoteItem }}
        </td>
        <td class="small-colunm pt-1">
            <v-tooltip top max-width=750>
                  <span slot="activator">
                    <span class="circulo" v-if="value.tipoNegociacao === 'Exclusivo'"><span>E</span></span>
                    <span class="circulo" v-else><span>D</span></span>
                  </span>
              <span v-if="value.tipoNegociacao === 'Exclusivo'">Exclusivo</span>
              <span v-else>Diferenciado</span>
            </v-tooltip>
            <v-tooltip top max-width=750>
                <span slot="activator">
                  {{ value.itemCompraDescricao | az-clip-text(50) }}
                </span>
                <span>{{value.itemCompraDescricao}}</span>
            </v-tooltip>
        </td>
        <td class="small-colunm">{{ value.quantidade }}</td>
        <td class="input-small">
            <span v-if="esconderCamposProposta">
                {{getAtributoVisualizacao(value.marca)}}
            </span>
            <v-text-field v-model="value.marca" v-else maxlength="200"></v-text-field>
        </td>
        <td class="input-small">
            <span v-if="esconderCamposProposta">
                {{getAtributoVisualizacao(value.modelo)}}
            </span>
            <v-text-field v-model="value.modelo" v-else maxlength="200"></v-text-field>
        </td>
        <td class="input-small" v-if="ehAmparoLei14133Art82">
          <span v-if="esconderCamposProposta">{{getAtributoVisualizacao(value.quantidadeProposta)}}</span>
          <v-text-field v-else v-validate="'required|integer|min_value:1|max_value:'+value.quantidade" v-model.number="value.quantidadeProposta" type="number"
                        :error-messages="errors.collect('Quantidade Proposta '+ value.licitacaoLoteItemId)"
                        :name="'Quantidade Proposta '+ value.licitacaoLoteItemId" max-length="8" @blur="salvarItem()"
          ></v-text-field>
        </td>
        <td  class="small-colunm" style="text-align: right;" v-if="licitacao.mostrarValorReserva">
            <formatador-moeda :valor="value.valorUnitarioReferencia"
                              :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
        </td>
        <td style="text-align: right;" class="input-small">
            <span v-if="esconderCamposProposta">{{ precoVisualizacao }}</span>
            <campo-moeda @eventoFoco="salvarItem()" v-model="value.preco" :casas-decimais="licitacao.casasDecimais" :id-campo="value.licitacaoLoteItemId" :menor-preco="isMenorPreco" v-else></campo-moeda>
        </td>
        <td style="text-align: right;" v-if="isMenorPreco"  class="small-colunm">
            <span v-if="esconderCamposProposta">{{valorTotalItemFormatado}}</span>
            <formatador-moeda :valor="valorTotalItem" :casas-decimais="2" v-else></formatador-moeda>
        </td>
        <td class="anexos">
            <div v-if="(isLoteExclusivo && isFornecedorMicroEmpresa) || !isLoteExclusivo">
                <licitacao-fornecedor-proposta-item-anexo @eventoUpload="salvarItem()"
                                                          v-if="value.incluirFicha && podeEditarArquivos(value.fichaTecnica)"
                                                          v-model="value" tipo-anexo="fichaTecnica"/>
                <licitacao-fornecedor-proposta-item-anexo @eventoUpload="salvarItem()"
                                                          v-if="value.incluirCatalogo && podeEditarArquivos(value.catalogo)"
                                                          v-model="value" tipo-anexo="catalogo"/>
            </div>
            <div v-else style="text-align: center">-</div>
        </td>
    </tr>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import accounting from 'accounting'
import FormatadorMoeda from '@/commons/components/FormatadorMoeda.vue'
import CampoMoeda from '@/commons/components/CampoMoeda.vue'
import LicitacaoFornecedorPropostaItemAnexo from './CredenciamentoFornecedorPropostaItemAnexo.vue'
import {actionTypes, tiposLicitacao} from '@/commons/constants'

const LOTE_EXCLUSIVO = 'Exclusivo'

    export default {
        name: 'LicitacaoFornecedorPropostaItem',
        inject: ['$validator'],
        components: {CampoMoeda, FormatadorMoeda, LicitacaoFornecedorPropostaItemAnexo},
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapState(['licitacao', 'propostaResumo', 'termoAceiteProposta']),
            descricaoLoteItem() {
                return this.value.loteDescricao + '/' + this.value.itemCompraCodigo
            },
            isFornecedorMicroEmpresa() {
                return this.termoAceiteProposta && this.termoAceiteProposta.microEmpresa === 'S'
            },
            isPropostaEnviada() {
                return this.propostaResumo.enviada
            },
            isLoteExclusivo() {
                return this.value.tipoNegociacao === LOTE_EXCLUSIVO
            },
            esconderCamposProposta() {
                return this.isPropostaEnviada || (this.isLoteExclusivo && !this.isFornecedorMicroEmpresa)
            },
            precoVisualizacao() {
                if (this.value.preco && this.value.preco !== '0,00' || !this.isMenorPreco) {
                    return accounting.formatNumber(accounting.unformat(this.value.preco, ','), this.licitacao.casasDecimais, '.', ',')
                }
                return '-'
            },
            tipoNegociacao() {
                return this.value.tipoNegociacao === LOTE_EXCLUSIVO ? 'Sim' : 'Não'
            },
            valorTotalItem() {
                if(this.licitacao.amparoLegal && this.licitacao.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV') {
                  const preco = accounting.unformat(this.value.preco, ',')
                  return preco * this.value.quantidadeProposta
                }
                const preco = accounting.unformat(this.value.preco, ',')
                return preco * this.value.quantidade
            },
            valorTotalItemFormatado() {
                const valorTotal = this.valorTotalItem
                return valorTotal > 0 ? accounting.formatNumber(valorTotal, 2, '.', ',') : '-'
            },
            isMenorPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
            },
            ehAmparoLei14133Art82() {
              return this.licitacao.amparoLegal && this.licitacao.amparoLegal.lei === 'Lei 14.133/2021, Art. 82, IV'
            }
        },
        methods: {
            getAtributoVisualizacao(atributo) {
                return atributo ? atributo : '-'
            },
            podeEditarArquivos(arquivo) {
                if (this.isPropostaEnviada && !arquivo) {
                    return false
                }
                return true
            },
            criarPayload (){
                const payload = {
                    'licitacaoLoteItemId' : this.value.licitacaoLoteItemId,
                    'preco' : accounting.unformat(this.value.preco, ','),
                    'quantidade' : this.value.quantidade,
                    'quantidadeProposta' : this.value.quantidadeProposta,
                    'marca' : this.value.marca,
                    'modelo' : this.value.modelo,
                    'loteId' : this.value.loteId,
                    'fichaTecnica' : this.value.fichaTecnica,
                    'catalogo' : this.value.catalogo
                }

                return payload
            },
            validarFicha(){
                return this.value.incluirFicha ? this.value.fichaTecnica != null && !(!this.value.fichaTecnica.anexoUri) : true
            },
            validarCatalogo(){
                return this.value.incluirCatalogo ? this.value.catalogo != null && !(!this.value.catalogo.anexoUri) : true
            },
            validarPreco(payload){
                return payload.preco != null && payload.preco > 0
            },
            async validarQtd(){
              if(!this.ehAmparoLei14133Art82){
                return true
              }
              return await this.$validator.validate('Quantidade Proposta '+ this.value.licitacaoLoteItemId);
            },
            async salvarItem(){
                const payload = this.criarPayload()

                if(this.validarFicha() && this.validarCatalogo() && this.validarPreco(payload) && await this.validarQtd(payload)) {
                  this.$emit('atualizarItemProposta', {licitacaoId: this.licitacao.id, payload})
                }
            },
        }
    }
</script>

<style lang="stylus">
    .input-small
        padding 0px 10px !important
        .v-text-field
            margin: 0 !important;
            padding-top: 0 !important
        input
            max-height: 20px;
            font-size: 13px;
            color: #777 !important;

    .small-colunm
        padding 0px 10px !important

    .circulo {
      width: 1.8em
      height: 1.8em
      border-radius: 50%
      background-color: #bbb
      display: inline-flex
      justify-content: center
      align-items: center
      font-size: 12px
      font-weight: bold
      color: white
    }

    .circulo span {
      text-align: center
      line-height: 20px
    }

</style>